import React from 'react';
import '../less/expressEnergy.less';
import Banner from '../../../../auxiliary-components/shared/Banner';
import banner_img from '../img/banner_img.png';
import usage_block_data from '../enums/usage_block_data.json';
import UsageBlock from '../../../../auxiliary-components/shared/UsageBlock';
import FilesForDownload from '../../../../auxiliary-components/shared/FilesForDownload/views/file.c';
import Calculator from '../../../../auxiliary-components/Calculator';
import { getUrl } from "utils/corploansUrl";
import purpose_img from "../img/purpose_img.png";
import darex_logo from "../img/darex_logo.svg";
import foxtrot_logo from "../img/foxtrot_logo.svg";
import epicentr_logo from "../../EnergyIndependence/img/epicentr_logo.svg";
import citrus_logo from "../../EnergyIndependence/img/citrus_logo.svg";
import SliderComponent from "../../../../auxiliary-components/shared/Slider";
import { Preloader } from 'MWC';
import special_proposal_img from "../img/special_proposal_img.png";
import DOMPurify from 'dompurify';
import { applyDarex, expressEnergyCitrus, expressEnergyDarex, expressEnergyEpicentr, expressEnergyFoxtrot } from '../../../../services/urls/urls';

export default function template() {
    const isMobile = this.isViewportMobile(),
    model = this.getModel(),
      calc = !model.creditSum ? (
        ''
      ) : (
        <div className="credit-calculator">
            <div className="calculator-wrapper">
                <Calculator model={this.getModel()} type="express-energy" {...this.props} toggleModal={this.toggleModal} />
            </div>
        </div>
      );
    return (
        <div className='module-services'>
            <div className='express-energy-module'>
              <div className='slider-container'>
                {this.state.loader ? <Preloader></Preloader> : <SliderComponent isMobile={isMobile} widget={this.widgetsHelper.getWidget.call(this, 'main_banner')}></SliderComponent>}
              </div>
                <div className='content'>
                  <div className='purpose-block'>
                    <div className='purpose-block-left-side'>
                      <div className='purpose-block-left-side-title' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('EXPRESS_ENERGY_WE_CREDIT'))}}></div>
                      <div className='purpose-block-left-side-text' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('EXPRESS_ENERGY_WE_CREDIT_TEXT'))}}></div>
                      <ul className='purpose-block-left-side-list'>
                        <li className='purpose-block-left-side-list-item' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('EXPRESS_ENERGY_ITEM_1'))}}></li>
                        <li className='purpose-block-left-side-list-item' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('EXPRESS_ENERGY_ITEM_2'))}}></li>
                        <li className='purpose-block-left-side-list-item' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('EXPRESS_ENERGY_ITEM_3'))}}></li>
                        <li className='purpose-block-left-side-list-item' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('EXPRESS_ENERGY_ITEM_4'))}}></li>
                        <li className='purpose-block-left-side-list-item' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('EXPRESS_ENERGY_ITEM_5'))}}></li>
                      </ul>
                      <button className='purpose-block-left-side-button' onClick={() => window.open(getUrl())}>{this.l10n('SEND_APPLICATION')}</button>
                    </div>
                    <div className='purpose-block-right-side'>
                      <img src={purpose_img} alt="purpose_img" className='purpose-block-right-side-img' />
                    </div>
                  </div>
                    <UsageBlock
                        isMobile={isMobile}
                        page={'express-energy'}
                        data={usage_block_data}
                        className='col-3-row-1'
                    ></UsageBlock>
                  <div className="special-proposal" id="darexoffer">
                    <div className="special-proposal__left">
                      <div className="special-proposal__title">{this.l10n('EXPRESS_ENERGY_SPECIAL_PROPOSAL_TITLE')}</div>
                      <div className="special-proposal__text">{this.l10n('EXPRESS_ENERGY_SPECIAL_PROPOSAL_TEXT')}</div>
                      <div className="special-proposal__btns">
                        <a target="_blank" href="/static/tariffs_darex_express-energy.pdf" className="special-proposal__btn special-proposal__btn_black">{this.l10n('EXPRESS_ENERGY_SPECIAL_PROPOSAL_BTN_1')}</a>
                        <a target="_blank" href={applyDarex} className="special-proposal__btn">{this.l10n('EXPRESS_ENERGY_SPECIAL_PROPOSAL_BTN_2')}</a>
                      </div>
                    </div>
                    <div className="special-proposal__image">
                      <img src={special_proposal_img} alt="" />
                    </div>
                  </div>
                  <div className='partners'>
                    <div className='partners-title'>{this.l10n('ENERGY_INDEPENDENCE_PARTNERS_TITLE')}</div>
                    <div className='partners-second'>
                      <a href={expressEnergyEpicentr} target='_blank' className='partners-second-item'>
                        <img src={epicentr_logo} alt="epicentr_logo" className='partners-second-item-img' />
                        <div className='partners-second-item-text'>{this.l10n('ENERGY_INDEPENDENCE_PARTNERS_TEXT_5')}</div>
                      </a>
                      <a href={expressEnergyCitrus} target='_blank' className='partners-second-item'>
                        <img src={citrus_logo} alt="citrus_logo" className='partners-second-item-img' />
                        <div className='partners-second-item-text'>{this.l10n('ENERGY_INDEPENDENCE_PARTNERS_TEXT_7')}</div>
                      </a>
                    </div>
                    <div className='partners-first'>
                      <a href={expressEnergyDarex} target='_blank' className='partners-first-item'>
                        <img src={darex_logo} alt="rozetka_logo" className='partners-first-item-img' />
                        <div className='partners-first-item-text'>{this.l10n('ENERGY_INDEPENDENCE_PARTNERS_TEXT_8')}</div>
                      </a>
                      <a href={expressEnergyFoxtrot} target='_blank' className='partners-first-item'>
                        <img src={foxtrot_logo} alt="comfy_logo" className='partners-first-item-img' />
                        <div className='partners-first-item-text'>{this.l10n('ENERGY_INDEPENDENCE_PARTNERS_TEXT_9')}</div>
                      </a>
                    </div>

                  </div>

                    {calc}

                    <FilesForDownload style={{marginBottom: 0}} lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}/>

                    </div>
            </div>
        </div>
    );
}
